module.exports = __webpack_public_path__ + "static/media/headset_icon.e5b1481b.svg";